/* Ficha técnica en PDF, generada en el navegador con jsPDF + autotable.
   La arma window.LCCFicha.generar(btn) a partir de los data-* del botón
   "Descargar ficha técnica" y de la tabla .ft-tabla del acordeón.
   Se carga desde snippets/ficha-tecnica-styles.liquid. */
(function () {
  var JSPDF_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
  var AUTOTABLE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js';
  var libLoading = null;

  var OSCURO = [31, 34, 40];
  var NARANJO = [255, 90, 0];
  var GRIS = [121, 117, 114];
  var TEXTO = [38, 38, 38];
  var CLARO = [244, 244, 244];

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('No se pudo cargar ' + src)); };
      document.head.appendChild(s);
    });
  }
  function loadJsPdf() {
    if (window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API.autoTable) return Promise.resolve();
    if (libLoading) return libLoading;
    libLoading = (window.jspdf && window.jspdf.jsPDF ? Promise.resolve() : loadScript(JSPDF_SRC))
      .then(function () { return loadScript(AUTOTABLE_SRC); });
    return libLoading;
  }

  /* Carga una imagen y la devuelve como data-URL. Opciones:
     - cover: relación ancho/alto a la que se recorta centrado (como object-fit: cover)
     - contain: lado del cuadrado blanco en el que se encaja entera
     - alpha: vuelve transparente el fondo oscuro (para el logo sobre la banda)  */
  function cargarImagen(url, op) {
    op = op || {};
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var c = document.createElement('canvas'), g;
          if (op.cover) {
            var r = op.cover, sw = w, sh = h;
            if (w / h > r) sw = Math.round(h * r); else sh = Math.round(w / r);
            c.width = Math.min(sw, 1400); c.height = Math.round(c.width / r);
            g = c.getContext('2d');
            g.drawImage(img, (w - sw) / 2, (h - sh) / 2, sw, sh, 0, 0, c.width, c.height);
          } else if (op.contain) {
            /* Igual que en el catálogo: se recorta el aire blanco alrededor de la palmeta
               y, si es una tabla o placa acostada, se para; así llena el cuadrado. */
            var t = document.createElement('canvas'); t.width = w; t.height = h;
            var tg = t.getContext('2d'); tg.drawImage(img, 0, 0);
            var px = tg.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
            for (var yy = 0; yy < h; yy += 2) for (var xx = 0; xx < w; xx += 2) {
              var k = (yy * w + xx) * 4;
              if (px[k] < 238 || px[k + 1] < 238 || px[k + 2] < 238) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
            }
            var sx = 0, sy = 0, sw = w, sh = h;
            if (x1 > 0 && (x1 - x0) * (y1 - y0) > w * h * 0.04) { sx = x0; sy = y0; sw = x1 - x0 + 2; sh = y1 - y0 + 2; }
            var girar = op.parar && sw > sh * 1.3;
            var L = op.contain; c.width = L; c.height = L;
            g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, L, L);
            var bw = girar ? sh : sw, bh = girar ? sw : sh;
            var esc = Math.min(L / bw, L / bh) * 0.94, dw = sw * esc, dh = sh * esc;
            g.save(); g.translate(L / 2, L / 2);
            if (girar) g.rotate(Math.PI / 2);
            g.drawImage(img, sx, sy, sw, sh, -dw / 2, -dh / 2, dw, dh);
            g.restore();
          } else {
            c.width = w; c.height = h; g = c.getContext('2d'); g.drawImage(img, 0, 0);
          }
          if (op.alpha) {
            var id = g.getImageData(0, 0, c.width, c.height), d = id.data;
            for (var i = 0; i < d.length; i += 4) {
              var lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
              var sat = Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2]);
              if (sat < 40) d[i + 3] = lum < 50 ? 0 : lum < 120 ? Math.round((lum - 50) / 70 * 255) : 255;
            }
            g.putImageData(id, 0, 0);
            resolve({ dataUrl: c.toDataURL('image/png'), tipo: 'PNG', w: c.width, h: c.height });
          } else {
            resolve({ dataUrl: c.toDataURL('image/jpeg', 0.86), tipo: 'JPEG', w: c.width, h: c.height });
          }
        } catch (e) { console.warn('[Ficha PDF] imagen', url, e); resolve(null); }
      };
      img.onerror = function () { console.warn('[Ficha PDF] no cargó', url); resolve(null); };
      img.src = url;
    });
  }

  /* La Helvetica de jsPDF solo trae Latin-1: se cambian los símbolos que no tiene. */
  function pdfSafe(s) {
    if (s == null) return '';
    return String(s)
      .replace(/≤/g, '<=').replace(/≥/g, '>=').replace(/≠/g, '!=').replace(/≈/g, '~')
      .replace(/…/g, '...').replace(/–|—/g, '-').replace(/[“”]/g, '"').replace(/[‘’]/g, "'")
      .replace(/™/g, '(TM)').replace(/©/g, '(c)').replace(/®/g, '(R)')
      .replace(/³/g, '3').replace(/⁴/g, '4').replace(/⁵/g, '5');
  }

  function specsDesdeDom(btn) {
    var details = btn.closest('details');
    var rows = details ? details.querySelectorAll('.ft-tabla tr') : [];
    var specs = [];
    rows.forEach(function (tr) {
      var c = tr.querySelectorAll('td');
      if (c.length >= 2) {
        var k = pdfSafe((c[0].textContent || '').trim());
        var v = pdfSafe((c[1].textContent || '').trim());
        if (k && v) specs.push([k, v]);
      }
    });
    return specs;
  }

  function buscar(specs, claves) {
    for (var i = 0; i < claves.length; i++) {
      for (var j = 0; j < specs.length; j++) {
        if (specs[j][0].toLowerCase() === claves[i]) return specs[j][1];
      }
    }
    return '';
  }

  function fecha() {
    return new Date().toLocaleDateString('es-CL', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  /* Texto con letras separadas, para los rótulos chicos en mayúscula */
  function rotulo(pdf, texto, x, y, op) {
    op = op || {};
    pdf.setCharSpace(op.espacio == null ? 0.6 : op.espacio);
    pdf.text(texto, x, y, op);
    pdf.setCharSpace(0);
  }

  function construir(d, specs, img) {
    var jsPDF = window.jspdf.jsPDF;
    var pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait', compress: true });
    var W = pdf.internal.pageSize.getWidth();
    var H = pdf.internal.pageSize.getHeight();
    var mx = 16;
    var ancho = W - 2 * mx;

    /* ── Banda superior ── */
    pdf.setFillColor.apply(pdf, OSCURO); pdf.rect(0, 0, W, 30, 'F');
    pdf.setFillColor.apply(pdf, NARANJO); pdf.rect(0, 30, W, 1.2, 'F');
    if (img.logo) {
      var lh = 13, lw = lh * (img.logo.w / img.logo.h);
      if (lw > 58) { lw = 58; lh = lw * (img.logo.h / img.logo.w); }
      pdf.addImage(img.logo.dataUrl, img.logo.tipo, mx, 15 - lh / 2, lw, lh);
    }
    pdf.setFont('helvetica', 'bold'); pdf.setFontSize(10); pdf.setTextColor(255, 255, 255);
    rotulo(pdf, 'FICHA TÉCNICA', W - mx, 13.5, { align: 'right', espacio: 1 });
    pdf.setFont('helvetica', 'normal'); pdf.setFontSize(7.5); pdf.setTextColor(183, 172, 162);
    pdf.text(pdfSafe(fecha()), W - mx, 19, { align: 'right' });

    /* ── Producto: palmeta + título + datos clave ── */
    var y = 40, lado = 72, tx = mx, tw = ancho;
    if (img.palmeta) {
      pdf.setDrawColor(225, 225, 225); pdf.setLineWidth(0.3);
      pdf.rect(mx, y, lado, lado, 'S');
      pdf.addImage(img.palmeta.dataUrl, img.palmeta.tipo, mx + 0.3, y + 0.3, lado - 0.6, lado - 0.6);
      tx = mx + lado + 9; tw = ancho - lado - 9;
    }
    var ty = y + 4;
    var fabricante = [d.productVendor, d.origen].filter(Boolean).join(' · ');
    if (fabricante) {
      pdf.setFont('helvetica', 'bold'); pdf.setFontSize(7); pdf.setTextColor.apply(pdf, NARANJO);
      rotulo(pdf, 'FABRICANTE', tx, ty);
      pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor.apply(pdf, TEXTO);
      pdf.text(pdfSafe(fabricante), tx, ty + 5);
      ty += 12;
    }
    pdf.setFont('helvetica', 'bold'); pdf.setFontSize(18); pdf.setTextColor.apply(pdf, TEXTO);
    var titulo = pdf.splitTextToSize(pdfSafe(d.productTitle || ''), tw).slice(0, 3);
    pdf.text(titulo, tx, ty + 5);
    if (d.productUrl) pdf.link(tx, ty, tw, titulo.length * 7.5, { url: d.productUrl });
    ty += titulo.length * 7.5 + 2;
    if (d.productSku) {
      pdf.setFont('helvetica', 'normal'); pdf.setFontSize(8); pdf.setTextColor.apply(pdf, GRIS);
      pdf.text(pdfSafe('SKU ' + d.productSku), tx, ty + 3);
      ty += 6;
    }

    /* Cuatro datos clave en cajas, abajo a la derecha de la palmeta */
    var claves = [
      ['FORMATO', d.formato || buscar(specs, ['formato'])],
      ['ACABADO', d.acabado || buscar(specs, ['acabado'])],
      ['ASPECTO', d.aspecto || buscar(specs, ['aspecto'])],
      ['USO', d.uso || buscar(specs, ['uso', 'ubicación', 'ubicacion'])]
    ].filter(function (c) { return c[1]; });
    if (claves.length) {
      var cajaH = 14, gap = 3, cajaW = (tw - gap) / 2;
      var filas = Math.ceil(claves.length / 2);
      var cy = Math.max(ty + 4, y + lado - filas * cajaH - (filas - 1) * gap);
      claves.forEach(function (c, i) {
        var cx = tx + (i % 2) * (cajaW + gap), yy = cy + Math.floor(i / 2) * (cajaH + gap);
        pdf.setFillColor.apply(pdf, CLARO);
        pdf.roundedRect(cx, yy, cajaW, cajaH, 1.5, 1.5, 'F');
        pdf.setFont('helvetica', 'bold'); pdf.setFontSize(6.5); pdf.setTextColor.apply(pdf, GRIS);
        rotulo(pdf, c[0], cx + 4, yy + 5);
        pdf.setFont('helvetica', 'bold'); pdf.setFontSize(10.5); pdf.setTextColor.apply(pdf, TEXTO);
        var val = pdf.splitTextToSize(pdfSafe(c[1]), cajaW - 8)[0];
        pdf.text(val, cx + 4, yy + 10.5);
      });
      ty = cy + filas * cajaH + (filas - 1) * gap;
    }
    y = Math.max(y + lado, ty) + 12;

    /* ── Características técnicas ── */
    pdf.setFont('helvetica', 'bold'); pdf.setFontSize(9.5); pdf.setTextColor.apply(pdf, TEXTO);
    rotulo(pdf, pdfSafe((d.pdfTitle || 'Características técnicas').toUpperCase()), mx, y);
    pdf.setFillColor.apply(pdf, NARANJO); pdf.rect(mx, y + 2.2, 16, 0.8, 'F');
    y += 7;

    var tablaFin = y;
    if (specs.length && pdf.autoTable) {
      /* Dos columnas de clave/valor para que la ficha quepa en una página */
      var mitad = Math.ceil(specs.length / 2), body = [];
      for (var i = 0; i < mitad; i++) {
        var a = specs[i], b = specs[i + mitad] || ['', ''];
        body.push([a[0], a[1], b[0], b[1]]);
      }
      var colK = 30, colV = ancho / 2 - colK - 2;
      pdf.autoTable({
        startY: y,
        body: body,
        theme: 'plain',
        styles: { font: 'helvetica', fontSize: 8, cellPadding: { top: 2.1, bottom: 2.1, left: 2, right: 2 }, textColor: TEXTO, lineColor: [232, 232, 232], lineWidth: { bottom: 0.2 }, valign: 'middle' },
        columnStyles: {
          0: { cellWidth: colK, textColor: GRIS },
          1: { cellWidth: colV, fontStyle: 'bold' },
          2: { cellWidth: colK, textColor: GRIS },
          3: { cellWidth: colV, fontStyle: 'bold' }
        },
        margin: { left: mx, right: mx },
        didParseCell: function (data) {
          if (data.column.index === 1) data.cell.styles.cellPadding = { top: 2.1, bottom: 2.1, left: 2, right: 6 };
        }
      });
      tablaFin = pdf.lastAutoTable.finalY;
    } else if (!specs.length) {
      pdf.setFont('helvetica', 'normal'); pdf.setFontSize(9); pdf.setTextColor.apply(pdf, GRIS);
      pdf.text('Sin datos de ficha técnica disponibles.', mx, y + 6);
      tablaFin = y + 10;
    }

    /* ── Ambiente, si queda espacio ── */
    var pieY = H - 16;
    var libre = pieY - 8 - (tablaFin + 8);
    if (img.ambiente && libre >= 42) {
      var ah = Math.min(libre - 6, 78), aw = ancho, ay = tablaFin + 8;
      pdf.addImage(img.ambiente.dataUrl, img.ambiente.tipo, mx, ay, aw, ah);
      pdf.setFont('helvetica', 'normal'); pdf.setFontSize(7); pdf.setTextColor.apply(pdf, GRIS);
      pdf.text('Ambiente referencial. Las fotos son orientativas y el tono real puede variar según la partida.', mx, ay + ah + 4);
    }

    /* ── Pie ── */
    pdf.setFillColor.apply(pdf, OSCURO); pdf.rect(0, pieY, W, H - pieY, 'F');
    pdf.setFont('helvetica', 'bold'); pdf.setFontSize(8.5); pdf.setTextColor(255, 255, 255);
    pdf.text(pdfSafe(d.pdfFooter || 'La Casa de la Cerámica · lacasadelaceramica.cl'), mx, pieY + 6.5);
    pdf.setFont('helvetica', 'normal'); pdf.setFontSize(7); pdf.setTextColor(183, 172, 162);
    var pie2 = [d.pdfContacto, 'Precio y stock actualizados en la ficha web del producto'].filter(Boolean).join('   ·   ');
    pdf.text(pdfSafe(pie2), mx, pieY + 11.5);
    if (d.productUrl) {
      pdf.setFontSize(7); pdf.setTextColor.apply(pdf, NARANJO);
      var u = d.productUrl.replace(/^https?:\/\//, '');
      pdf.text(u, W - mx, pieY + 6.5, { align: 'right' });
      pdf.link(W - mx - pdf.getTextWidth(u), pieY + 3, pdf.getTextWidth(u), 5, { url: d.productUrl });
    }
    return pdf;
  }

  function generar(btn) {
    var d = btn.dataset;
    return loadJsPdf().then(function () {
      return Promise.all([
        cargarImagen(d.pdfLogo, { alpha: true }),
        cargarImagen(d.imagePalmeta || d.productImage, { contain: 900, parar: !/guardapolvo/i.test(d.productTitle || '') }),
        cargarImagen(d.imageAmbiente, { cover: 178 / 70 })
      ]);
    }).then(function (im) {
      return construir(d, specsDesdeDom(btn), { logo: im[0], palmeta: im[1], ambiente: im[2] });
    });
  }

  window.LCCFicha = { generar: generar, construir: construir, cargarImagen: cargarImagen };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ft-pdf]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Generando…';
    generar(btn)
      .then(function (pdf) { pdf.save('Ficha tecnica - ' + (btn.dataset.productTitle || 'producto').replace(/[\\/:*?"<>|]+/g, ' ') + '.pdf'); })
      .catch(function (err) {
        console.error('[Ficha PDF]', err);
        alert('No se pudo generar el PDF: ' + (err && err.message ? err.message : 'error desconocido'));
      })
      .then(function () { btn.disabled = false; if (label) label.textContent = original; });
  });
})();
